export enum Frequency {
  MONTHLY = "monthly",
  QUARTERLY = "quarterly",
  BIANNUALLY = "biannually",
  ANNUALLY = "annually",
  EVERY_FOUR_YEARS = "every_four_years",
}
